import { c as _c } from "react/compiler-runtime";
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterUpdateInterface } from 'modules/newsletters/single/types/newsletter-update-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { NewsletterViewApiType } from '../types/newsletter-view-interface';
export const useUpdateNewsletter = id => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== id) {
    t1 = {
      fetcherUpdateNewsletter: payload => fetcher(`${NEWSLETTERS_API}/${id}`, payload)
    };
    $[1] = fetcher;
    $[2] = id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};